// Google Analytics tracking
// Replace 'G-XXXXXXXXXX' with your Google Analytics Measurement ID

export const initGA = (measurementId) => {
  if (typeof window !== 'undefined' && measurementId) {
    // Load Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId, {
      page_path: window.location.pathname + window.location.search,
    });

    // Track page views on route changes
    return gtag;
  }
  return null;
};

export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Use the Measurement ID from the script tag or environment variable
    const measurementId = 'G-MP3D4D91GB' || process.env.REACT_APP_GA_MEASUREMENT_ID;
    window.gtag('config', measurementId, {
      page_path: path,
    });
  }
};

export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

